import { useEffect, useRef, useState } from 'react';
import { BlockUnit } from '../BlockUnit/BlockUnit';
import './BlockUnitGrid.css';
import { v4 as uuidv4 } from 'uuid';

function BlockUnitGrid( { params } ) {

    const n = [...Array(params.rowCount).keys()];
   
    return (
        <table className="BlockGrid">
            <tbody>
            {n.map((i)=>{
                const paramsCopy = {...params}
                paramsCopy.shape = params.shape[Number(i)];
                paramsCopy.row = i;
                return (<BlockUnitGridRow params={ paramsCopy } key={uuidv4()}></BlockUnitGridRow>)
            })}
            </tbody>
        </table>
    );
}

function BlockUnitGridRow( { params } ) {
  
    const m =  [...Array(params.colCount).keys()]
    return (
        <tr className="BlockGridRow">
        {m.map((i)=>{
            const paramsCopy = {...params}
            paramsCopy.shape = params.shape[Number(i)];
            paramsCopy.column = i;
            return (<BlockUnitGridBlock params={paramsCopy} key={uuidv4()}></BlockUnitGridBlock>)
        })}
        </tr>
    );
}

function BlockUnitGridBlock( { params } ) {
    params.isEmpty = params.shape === 1;
    params.color = params.shape === 1 ? (params.color || 'red') : 'transparent';
    params.isOutline = (params.isOutline || params.isEmpty)

    const blockRef = useRef(null);
    useEffect(()=>{
       
        const block = blockRef.current;
        
        if(params.onClickCallback){
            block.addEventListener('mouseup', params.onClickCallback);
            block.addEventListener('touchend', params.onClickCallback);

            return () => {
                block.removeEventListener('mouseup', params.onClickCallback);
                block.addEventListener('touchend', params.onClickCallback);
            };
        }
    },[]);
   
    return (
        <td ref={blockRef} row={params.row} column={params.column}>
        <BlockUnit params={params}></BlockUnit>
        </td>
    );
}

export default BlockUnitGrid;